export class MDCasteCertificateBodyModel {
    constructor(
        public isDocReadable: string,
        public hasBarcode: string,
    ) { }
}